module.exports = "/_next/static/images/2c3519a041a67aaeb774c665a7e9bdde-kit-logo.png.webp";